import React from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import SubmenuWriteOff from '../submenu/SubmenuWriteOff'
import WriteOffActOptions from './options/WriteOffActOptions'
import WriteOffActFilters from './filters/WriteOffActFilters'
import WriteOffActList from './WriteOffActList'

const WriteOffActs = () => {
  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuWriteOff />
		</MyBlock>
		<MyBlockHeader
            header={'Заявки на списання'}
            options={
                <WriteOffActOptions />
            }
        />
		<MyBlock>
            <WriteOffActFilters />
        </MyBlock>
		<MyBlock>
			<WriteOffActList />
		</MyBlock>
    </LayoutMain>
  )
}

export default WriteOffActs